import { render, staticRenderFns } from "./ModalNewEditProcess.vue?vue&type=template&id=48e22dd7"
import script from "./ModalNewEditProcess.vue?vue&type=script&lang=js"
export * from "./ModalNewEditProcess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports